import PropTypes from 'prop-types';
import React from 'react';
import QuestionWrapper from '../response/QuestionWrapper';
import Input from './Input';

const PasswordQuestion = props => {
  const { id, name, required } = props;
  return (
    <QuestionWrapper {...props}>
      <Input
        field_type="text"
        name={`questions[${name}][]`}
        questionId={id}
        required={required}
      />
    </QuestionWrapper>
  );
};

PasswordQuestion.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  text: PropTypes.string.isRequired,
};

PasswordQuestion.defaultProps = {
  number_of_fields: 1,
};

export default PasswordQuestion;
